import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import Loading from "../ui/Loading.js";
import $ from "jquery";
import "moment/min/locales";
import "xlsx/dist/xlsx.full.min.js";
import { FormattedMessage, injectIntl } from "react-intl";
import { formatCantidad } from '../../commons/utils/Helpers';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import Backdrop from "@material-ui/core/Backdrop";
import Dialog from '../../commons/dialog/Dialog';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import { Grid, List, ListItem, ListItemText, Chip } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import PresupuestoDetalladoEditModal from "./PresupuestoDetalladoEditModal";
import ValidacionAutomaticaTooltip from './ValidacionAutomaticaTooltip.jsx'
import MessageTooltip from '../ui/commons/tooltip/MessageTooltip.jsx'

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90vw',
	maxWidth: 500,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
};

const requiredSymbol = ' *';

function Row(props) {
	const intl = props.intl;
	const [presupuestoItem, setPresupuestoItem] = useState(props.presupuestoItem);
	const [showModalEdit, setShowModalEdit] = useState(false);

	const [isMecanicoDropdownOpen, setIsMecanicoDropdownOpen] = useState(false);
	const [mecanicoSearchInput, setMecanicoSearchInput] = useState('');
	const [selectedMecanicos, setSelectedMecanicos] = useState(
		props.presupuestoItem.mecanico_ids || []
	);
	const mecanicoDropdownRef = useRef(null);

	useEffect(function() {
		if (!props.mecanicos || !props.mecanicos.length) return;
		setSelectedMecanicos(function(prev) {
			if (!prev.length) return prev;
			if (typeof prev[0] === 'object') return prev;
			var resueltos = prev.map(function(id) {
				return props.mecanicos.find(function(m) { return m.id === id || m.id === parseInt(id, 10); });
			}).filter(Boolean);
			return resueltos;
		});
	}, [props.mecanicos]);

	// VEC-3231: soloLectura griseo el box completo (sin permiso de carga de ese tipo de ítem).
	// Reusa la maquinaria de "bloqueado" de VEC-3203 (griseo + candado + dropdown mecánicos deshabilitado).
	var bloqueado = props.soloLectura || (props.esRecotizacionParcial
		&& presupuestoItem.estado_recotizacion !== 'rechazado'
		&& presupuestoItem.estado_recotizacion !== 'nuevo');

	useEffect(function() {
		function handleClickOutside(e) {
			if (mecanicoDropdownRef.current && !mecanicoDropdownRef.current.contains(e.target)) {
				setIsMecanicoDropdownOpen(false);
				setMecanicoSearchInput('');
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return function() {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const mecanicosFiltrados = (props.mecanicos || []).filter(function(m) {
		if (!mecanicoSearchInput) return true;
		var search = mecanicoSearchInput.toLowerCase();
		return m.nombreCompleto && m.nombreCompleto.toLowerCase().indexOf(search) !== -1;
	});

	const handleSelectMecanico = function(mecanico) {
		var yaSeleccionado = selectedMecanicos.find(function(m) { return m.id === mecanico.id; });
		if (yaSeleccionado) return;
		var nuevos = selectedMecanicos.concat([mecanico]);
		setSelectedMecanicos(nuevos);
		setMecanicoSearchInput('');
		props.updateServicioItem({ mecanico_ids: nuevos.map(function(m) { return m.id; }) }, props.index);
	};

	const handleDeleteMecanico = function(mecanico) {
		var nuevos = selectedMecanicos.filter(function(m) { return m.id !== mecanico.id; });
		setSelectedMecanicos(nuevos);
		props.updateServicioItem({ mecanico_ids: nuevos.map(function(m) { return m.id; }) }, props.index);
	};

	const useStylesCambioLlanta = makeStyles((theme) => ({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: "15px",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0px solid #000",
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
			borderRadius: "15px",
		},
	}));

	const classesCambio = useStylesCambioLlanta();

	const total = () => {
		let total = null;
		if(presupuestoItem.cantidad !== null){
			if(presupuestoItem.costo !== null){
				total = presupuestoItem.cantidad * presupuestoItem.costo;
			}
		}
		return total;
	};

	const aplicarCambio = (data) => {
		props.updateServicioItem(data, props.index);
		const updatedItem = { ...presupuestoItem };
		updatedItem.cantidad = data.cantidad;
		updatedItem.costo = data.costo;
		updatedItem.detalle = data.detalle;
		updatedItem.clasificacion = data.clasificacion;
		updatedItem.id_clasificacion = data.id_clasificacion;
		setPresupuestoItem(updatedItem);
		closeModalEdit();
	};

	const updateElement = (data) => {
		if (presupuestoItem.estado_recotizacion === 'aprobado') {
			Dialog.confirm(
				intl,
				{
					title: intl.formatMessage({ id: 'recotizacion.warning.titulo', defaultMessage: 'Ítem aprobado' }),
					text: intl.formatMessage({ id: 'recotizacion.warning.texto', defaultMessage: 'Este ítem fue aprobado en la revisión. ¿Confirmás que querés modificarlo?' }),
					icon: 'warning',
					confirmText: intl.formatMessage({ id: 'recotizacion.warning.confirmar', defaultMessage: 'Sí, modificar' }),
					cancelText: intl.formatMessage({ id: 'recotizacion.warning.cancelar', defaultMessage: 'Cancelar' }),
				},
				() => { aplicarCambio(data); }
			);
		} else {
			aplicarCambio(data);
		}
	};

	const closeModalEdit = (event) => {
		setShowModalEdit(false);
	};

	const edit = (event) => {
		event.preventDefault();
		setShowModalEdit(true)
	}

	/**
	 * VEC-3316 — el disponible del ítem, al lado de la cantidad pedida.
	 *
	 * Va acá y no en una columna propia porque las columnas de esta grilla las define la config
	 * `tickets.presupuesto.items.show`, y sumar una obligaría a cambiársela a todos los clientes.
	 * Al lado de la cantidad además es donde la comparación se lee sola: "pedís 20, hay 16".
	 *
	 * `stockPorItem` llega solo desde el presupuesto detallado. Los otros consumidores de esta
	 * grilla (el cierre de tareas) no lo pasan, y ahí no se pinta nada — que es lo correcto: no
	 * preguntaron por el stock.
	 *
	 * Misma regla que el resto de la card: null es "no se puede saber" y no se pinta; 0 es
	 * "Sin stock"; y si lo pedido supera lo disponible, va en rojo.
	 */
	const renderStockDelItem = () => {
		const mapa = props.stockPorItem;

		if (!mapa) return null;

		// VEC-3316: sin fallback a `.id` — en una línea persistida sin catálogo (repuesto de
		// descripción libre) `.id` es el id de `presupuesto_items`, no de `items`, y terminaría
		// pintando el stock de un ítem ajeno. `.id_item` viaja correcto en los dos casos: ya
		// persistido, o recién elegido en el select (ver `PresupuestoDetalladoItem.js`).
		const id = presupuestoItem.id_item;
		const disponible = id ? mapa[String(id)] : undefined;

		if (disponible === null || disponible === undefined) return null;

		const pedida = Number(presupuestoItem.cantidad || 0);
		const clase = disponible === 0 || pedida > disponible ? 'badge badge-danger' : 'badge badge-success';

		return (
			<span className={clase} style={{ marginLeft: '8px', flexShrink: 0 }}>
				{disponible === 0
					? intl.formatMessage({ id: 'correctivosAbm.repuestos.sin_stock', defaultMessage: 'Sin stock' })
					: disponible}
			</span>
		);
	};

	const renderTableTbody = (field, index) => {
		switch (field) {
			case 'index':
				return (
					<td key={index} className="all custom-lineHeight">
						{props.index + 1}
					</td>
				);
			case 'id':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoItem.id_item}
					</td>
				);
			case 'external_code':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoItem.external_code}
					</td>
				);
			case 'descripcion':
				return (
					<td key={index} className="all custom-lineHeight" style={{ maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={presupuestoItem.descripcion}>
						{presupuestoItem.descripcion}
						{presupuestoItem.estado_recotizacion === 'rechazado' && presupuestoItem.comentario_rechazo ? (
							<MessageTooltip message={presupuestoItem.comentario_rechazo} color="warning"/>
						) : null}
					</td>
				);
			case 'clasificacion':
				return (
					<td key={index} className="all custom-lineHeight" style={{ maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={presupuestoItem.clasificacion}>
						{presupuestoItem.clasificacion}
					</td>
				);
			case 'detalle':
				return (
					<td key={index} className="all custom-lineHeight" style={{ maxWidth: '130px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={presupuestoItem.detalle}>
						{presupuestoItem.detalle}
					</td>
				);
			case 'cuenta_mayor':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoItem.cuenta_mayor}
					</td>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoItem.cuenta_mayor_descripcion}
					</td>
				);
			case 'cantidad':
				return (
					<td key={index} className="all custom-lineHeight">
						{/*
							VEC-3316 — la cantidad a la izquierda y el stock pegado a la derecha.
							Con flex y `space-between` la celda se ve igual que antes cuando no hay
							badge que mostrar: un solo hijo queda alineado a la izquierda.
						*/}
						<div className="d-flex justify-content-between align-items-center">
							<span>{formatCantidad(presupuestoItem.cantidad)}</span>
							{renderStockDelItem()}
						</div>
					</td>
				);
			case 'costo':
				return (
					<td key={index} className="all custom-lineHeight">
						{LocaleFormat.formatPrice(presupuestoItem.costo)}
					</td>
				);
			case 'marcaNombre':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoItem.marcaNombre}
					</td>
				);
			case 'marca':
				return !props.marcaObligatorio ? (
					<td key={index} className="all custom-lineHeight">
						{presupuestoItem.marca ? presupuestoItem.marca.nombre : ''}
					</td>
				) : '';
			case 'total':
				return (
					<td key={index} className="all custom-lineHeight">
						{LocaleFormat.formatPrice(total())}
					</td>
				);
			case 'servicio':
				return (
					<td key={index} className="all custom-lineHeight">
						{
							presupuestoItem.servicio && presupuestoItem.servicio.nombre ?
								presupuestoItem.servicio.nombre :
								(
									presupuestoItem.servicio_nombre ? presupuestoItem.servicio_nombre : ''
								)
						}
						<ValidacionAutomaticaTooltip element={presupuestoItem} intl={intl} />
					</td>
				);
			case 'mecanico':
				if (props.tipoItem !== 'Mano De Obra') {
					return <td key={index} className="all custom-lineHeight"></td>;
				}
				return (
					<td key={index} className="all custom-lineHeight">
						<div style={{ position: 'relative' }} ref={mecanicoDropdownRef}>
							<div className="d-flex align-items-center">
								<div style={{ fontSize: '0.85rem' }}>
									{selectedMecanicos.length > 0
										? selectedMecanicos.map(function(m) { return m.nombreCompleto; }).join(', ')
										: '-'
									}
								</div>
								<i
									className="fa fa-chevron-down fa-2xs"
									style={{ marginLeft: '5px', fontSize: '11px', opacity: bloqueado ? 0.3 : 1, pointerEvents: bloqueado ? 'none' : 'auto', cursor: bloqueado ? 'default' : 'pointer' }}
									onClick={bloqueado ? null : function() {
										setIsMecanicoDropdownOpen(function(prev) { return !prev; });
									}}
								/>
							</div>
							{isMecanicoDropdownOpen && (
								<div
									style={{
										position: 'absolute',
										zIndex: 10,
										border: '1px solid #ccc',
										borderRadius: '4px',
										padding: '10px',
										backgroundColor: '#fff',
										minWidth: '220px',
										boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
									}}
								>
									<div style={{ marginBottom: '8px', fontWeight: 'bold', fontSize: '0.85rem' }}>
										<FormattedMessage id="Presupuesto.Mecanicos" defaultMessage="Mecánicos:" />
									</div>
									{selectedMecanicos.length > 0
										? selectedMecanicos.map(function(m, i) {
											return (
												<div key={i} style={{ paddingTop: '2px' }}>
													<Chip
														label={m.nombreCompleto}
														onDelete={function() { handleDeleteMecanico(m); }}
														style={{ marginRight: '5px', fontFamily: 'unset', fontSize: '0.85rem' }}
													/>
												</div>
											);
										})
										: <div style={{ fontSize: '0.8rem', color: '#999', marginBottom: '6px' }}>-</div>
									}
									<div style={{ marginTop: '8px' }}>
										<i className="fa fa-search fa-xs" style={{ marginRight: '4px' }} />
										<input
											className="form-control"
											type="text"
											placeholder={intl.formatMessage({ id: 'Buscar_Mecanico', defaultMessage: 'Buscar mecánico' })}
											value={mecanicoSearchInput}
											onChange={function(e) { setMecanicoSearchInput(e.target.value); }}
											style={{ display: 'inline-block', width: 'calc(100% - 20px)' }}
										/>
									</div>
									<hr style={{ margin: '6px 0' }} />
									<List style={{ paddingTop: 0, paddingBottom: 0, maxHeight: '180px', overflowY: 'auto' }}>
										{mecanicosFiltrados.map(function(m, i) {
											var yaSeleccionado = selectedMecanicos.find(function(s) { return s.id === m.id; });
											return (
												<ListItem
													key={i}
													onClick={function() { handleSelectMecanico(m); }}
													style={{
														cursor: yaSeleccionado ? 'default' : 'pointer',
														paddingTop: '3px',
														paddingBottom: '3px',
														opacity: yaSeleccionado ? 0.4 : 1,
													}}
												>
													<ListItemText primary={m.nombreCompleto} style={{ fontSize: '0.85rem' }} />
												</ListItem>
											);
										})}
									</List>
								</div>
							)}
						</div>
					</td>
				);
			default:
				return null;
		}
	}

	var rowStyle = {};
	if (bloqueado) {
		rowStyle = { opacity: 0.5, backgroundColor: '#f5f5f5' };
	} else if (presupuestoItem.estado_recotizacion === 'rechazado') {
		rowStyle = { backgroundColor: '#fff3cd' };
	}

	return (
		<React.Fragment>
			<tr key={presupuestoItem.id} style={rowStyle}>
				<Modal
					open={showModalEdit}
					onClose={closeModalEdit}
					className={classesCambio.modal}
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}
				>
					<Fade in={showModalEdit}>
						<Box sx={style}>
							<PresupuestoDetalladoEditModal
								type="presupuestoItem"
								intl={props.intl}
								element={presupuestoItem}
								updateElement={updateElement}
								closeModalEdit={closeModalEdit}
								enabledCosto={props.showItems.includes('costo')}
								enabledCantidad={props.showItems.includes('cantidad')}
								enabledDetalle={props.showItems.includes('detalle')}
								enabledClasificacion={props.showItems.includes('clasificacion')}
								clasificaciones={props.clasificaciones || []}
							/>
						</Box>
					</Fade> 
				</Modal>
				{props.showItems.map((field, index) => renderTableTbody(field, index))}

				<td className="all custom-lineHeight" style={{textAlign: 'center'}}>
					{bloqueado ? (
					<i
							className="fa fa-lock text-muted"
							title={props.soloLectura
								? intl.formatMessage({ id: 'PresupuestoDetalladoItemGrid.noEditable', defaultMessage: 'No editable' })
								: intl.formatMessage({ id: 'PresupuestoDetalladoItemGrid.bloqueado_tooltip', defaultMessage: 'Ítem aprobado en recotización parcial — no editable' })}
							style={{ fontSize: '14px' }}
						/>
					) : (
						<React.Fragment>
							<button
								className="btn btn-sm btn-icon btn-dt-grid text-warning"
								title={intl.formatMessage({ id: 'Editar', defaultMessage: 'Editar' })}
								data-togle="tooltip"
								data-placement="top"
								onClick={(event) => edit(event)}
							>
								<i className="fa fa-pencil fa-xs"/>
							</button>
							<button
								className="btn btn-sm btn-icon btn-dt-grid text-danger"
								title={intl.formatMessage({ id: 'Eliminar', defaultMessage: 'Eliminar' })}
								data-togle="tooltip"
								data-placement="top"
								onClick={() => props.deleteItem(props.index)}
							>
								<i className="fa fa-trash fa-xs"></i>
							</button>
						</React.Fragment>
					)}
				</td>
			</tr>


		</React.Fragment>
	);
}

const NEW_ITEM_INIT = {
	external_code: '',
	descripcion: '',
	clasificacion: '',
	id_clasificacion: null,
	detalle: '',
	cuenta_mayor: '',
	cuenta_mayor_descripcion: '',
	cantidad: '',
	costo: '',
	id_item: null,
	servicio_id: null,
	servicio: '',
	marcaNombre: '',
	id: null,
};

const PresupuestoDetalladoItemGrid = (props) => {
	const [loading, setLoading] = useState(false);
	const [presupuestoItems, setPresupuestoItems] = useState([]);
	useEffect(() => {
		setPresupuestoItems(props.presupuestoItems);
	}, [props.presupuestoItems]);


	const setLoadingAndUpdate = (state) => {
		setLoading(state);
	};

	const renderTableThead = (field, index) => {
		switch (field) {
			case 'index':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.items" defaultMessage="Items" />
					</th>
				);
			case 'id':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.id" defaultMessage="Id" />
					</th>
				);
			case 'external_code':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.repuesto" defaultMessage="Repuesto" />
					</th>
				);
			case 'descripcion':
				return (
					<th key={index} scope="col" style={{ minWidth: '110px', maxWidth: '160px' }}>
						<FormattedMessage id="presupuesto.descripción" defaultMessage="Descripción" />
					</th>
				);
			case 'clasificacion':
					return (
						<th key={index} scope="col" style={{ minWidth: '100px', maxWidth: '140px' }}>
							<FormattedMessage id="presupuesto.clasificacion" defaultMessage="Clasificación" />
						</th>
					);
			case 'detalle':
				return (
					<th key={index} scope="col" style={{ minWidth: '90px', maxWidth: '130px' }}>
						<FormattedMessage id="presupuesto.detalle" defaultMessage="Detalle" />
					</th>
				);
			case 'cuenta_mayor':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.cuenta_mayor" defaultMessage="Cuenta Mayor" />
					</th>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.descripcion_cuenta_mayor" defaultMessage="Descripción Cuenta Mayor" />
					</th>
				);
			case 'cantidad':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.cantidad" defaultMessage="Cantidad" />
					</th>
				);
			case 'costo':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.precio" defaultMessage="Precio" />
					</th>
				);
			case 'marcaNombre':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.marca" defaultMessage="Marca" />
					</th>
				);
			case 'marca':
				return !props.marcaObligatorio ? (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.marca" defaultMessage="Marca" />
					</th>
				) : '';
			case 'total':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.total" defaultMessage="Total" />
					</th>
				);
			case 'servicio':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="presupuesto.servicio" defaultMessage="Servicio" />
					</th>
				);
			case 'mecanico':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="Presupuesto.Mecanico" defaultMessage="Mecánico" />
					</th>
				);
			default:
				return null;
		}
	}

	return (
		<React.Fragment>
			<table
					id="dataTable"
					className="dataTable table nowrap server-side table-hover dataTableMovil"
					width="100%"
			>
				<thead>
					<tr>
						{props.showItems.map((field, index) => renderTableThead(field, index))}
						<th scope="col" style={{textAlign: 'center'}}>
						</th>
					</tr>
				</thead>
				<tbody>
					{props.presupuestoItems ? (
						props.presupuestoItems.map((presupuestoItem, index) => (
							<Row
								index={index}
								intl={props.intl}
								presupuestoItem={presupuestoItem}
								stockPorItem={props.stockPorItem}
								loading={(state) => setLoadingAndUpdate(state)}
								key={(presupuestoItem.external_code ? presupuestoItem.external_code: '') + presupuestoItem.descripcion + index}
								deleteItem={props.deleteItem}
								updateServicioItem={props.updateServicioItem}
								showItems={props.showItems}
								mecanicos={props.mecanicos}
								tipoItem={props.tipoItem}
								clasificaciones={props.clasificaciones || []}
								esRecotizacionParcial={props.esRecotizacionParcial || false}
								soloLectura={props.soloLectura || false}
							/>
						))
					) : (
						<tr>
							<td align={"center"} colSpan={14}>
								{loading ? (
									<CircularProgress />
								) : (
									<FormattedMessage
										id="Presupuesto.No_hay_datos_disponibles"
										defaultMessage="No hay datos disponibles."
									/>
								)}
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</React.Fragment>
	);
};

export default injectIntl(PresupuestoDetalladoItemGrid);
